import { IDto } from "./__types__/dto";
import { transform } from "./transform";
import { JoiPaginationScheme } from "./schemes/PaginationScheme";
import { DtoPaginationParser } from "./parsers/DtoPaginationParser";
import { DtoCuisineParser } from "./parsers/DtoCuisineParser";
import { DtoTechnicalRestaurantParser } from "./parsers/DtoTechnicalRestaurantParser";
import { DtoTranslatesParser } from "./parsers/DtoTranslatesParser";
import { JoiTechnicalRestaurantScheme } from "./schemes/DtoTechnicalRestaurantScheme";
import { JoiTranslatesScheme } from "./schemes/DtoTranslateScheme";
import { JoiCuisineScheme } from "./schemes/DtoCuisineScheme";
import { JoiTenantScheme } from "./schemes/DtoTenantScheme";
import { DtoTenantParser } from "./parsers/DtoTenantParser";
import { DtoOrderTechnicalEntityParser } from "./parsers/DtoOrderTechnicalParser";
import { JoiOrderTechnicalEntityScheme } from "./schemes/DtoOrderTechnicalScheme";
import { DtoTenantTokenParser } from "./parsers/DtoTenantTokenParser";
import { JoiTenantTokenScheme } from "./schemes/DtoTenantScheme copy";

export const dto: IDto = {
  Parsers: {
    Cuisine: DtoCuisineParser,
    Order: DtoOrderTechnicalEntityParser,
    Pagination: DtoPaginationParser,
    TechnicalRestaurant: DtoTechnicalRestaurantParser,
    Tenant: DtoTenantParser,
    TenantToken: DtoTenantTokenParser,
    Translates: DtoTranslatesParser,
  },
  Schemes: {
    Cuisine: JoiCuisineScheme,
    Order: JoiOrderTechnicalEntityScheme,
    Pagination: JoiPaginationScheme,
    TechnicalRestaurant: JoiTechnicalRestaurantScheme,
    Tenant: JoiTenantScheme,
    TenantToken: JoiTenantTokenScheme,
    Translates: JoiTranslatesScheme,
  },
  transform,
};
